import {getObject,postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
import {IClaim} from '../../lib/Models/ClaimModel'; 

export enum ErrorReturnMessage {
    details = "Unable to obtain patient credit details",
    notes = "Unable to update patient credit notes"
};

export interface IPatientCreditBalance { 
    totalCreditBalance: number,
    totalOpenBalance: number,
    patientRHC: string
}; export interface IPatientCreditNotes { 
    notes: string,
    auditing: string
}; 
export interface ICreditDetailsResponse {
    patientCreditInformation: IPatientCreditBalance,
    creditNotes?: IPatientCreditNotes,
    creditClaimList: IClaim[],
    openClaimList: IClaim[] 
};
export interface ICreditNotesRequest {
    PatientID: number,
    Notes: string
};
export interface ICreditNotesResponse {
    errorCode: number,
    errorMessage: string,
    auditing: string
};
export async function getCreditDetails(patientID: number, inputClaimID: number): Promise<IResultAndError<ICreditDetailsResponse>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/PatientCredit/CreditClaimSelect/${patientID}/${inputClaimID}`;
    const responseObject = await getObject<ICreditDetailsResponse>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.details;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function UpdatePatientCreditNotes(payload: ICreditNotesRequest): Promise<IResultAndError<ICreditNotesResponse>>{
    return postObjectWithApiError("api/Billing/PatientCredit/UpdatePatientCreditNotes", payload);
};
